/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Entry } from './Entry';
import {
    EntryFromJSON,
    EntryFromJSONTyped,
    EntryToJSON,
} from './Entry';

/**
 * 
 * @export
 * @interface ListWhitelistResponse
 */
export interface ListWhitelistResponse {
    /**
     * 
     * @type {Array<Entry>}
     * @memberof ListWhitelistResponse
     */
    entries: Array<Entry>;
}

/**
 * Check if a given object implements the ListWhitelistResponse interface.
 */
export function instanceOfListWhitelistResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "entries" in value;

    return isInstance;
}

export function ListWhitelistResponseFromJSON(json: any): ListWhitelistResponse {
    return ListWhitelistResponseFromJSONTyped(json, false);
}

export function ListWhitelistResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListWhitelistResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entries': ((json['entries'] as Array<any>).map(EntryFromJSON)),
    };
}

export function ListWhitelistResponseToJSON(value?: ListWhitelistResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'entries': ((value.entries as Array<any>).map(EntryToJSON)),
    };
}

